import { render, staticRenderFns } from "./press-center.vue?vue&type=template&id=76cb6ae2&scoped=true"
import script from "./press-center.vue?vue&type=script&lang=js"
export * from "./press-center.vue?vue&type=script&lang=js"
import style0 from "./press-center.vue?vue&type=style&index=0&id=76cb6ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb6ae2",
  null
  
)

export default component.exports